// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".circle{width:100%;height:100%;display:block;transition:opacity 0.3s linear;text-decoration:none}a.circle:hover{opacity:0.5}\n", ""]);
// Exports
module.exports = exports;
